import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./socialMediaButton.module.css";
const SocialMediaButton = ({ href, children, }) => {
    return (_jsx("a", { className: styles.socialMediaButton, href: href, target: "_blank", children: children }));
};
export default SocialMediaButton;
